<template lang="jade">
  .container-fluid
    .row
      .status_main.col-md-12
        header.status_title_bar.main_title_bar.clearfix
          h1.title.col-md-12.col-sm-10.col-xs-12
            | status
            span.deviceTime.col-md-3.pull-right.no_pad
              |{{deviceTime}}
        section.status_content.col-lg-12.col-md-12.col-sm-12.col-xs-12.no_pad
          header.status_header.clearfix
            h2.title_bar.col-lg-5.col-md-5.col-sm-7.clearfix input
            .pc_input_funtions.function_group.col-lg-4.col-md-4.col-sm-4.visible-sm.visible-md.visible-lg.no_pad
              .function__single.col-xs-6
                button.btn.col-xs-12.btn-default(
                  v-bind:class="{'btn-success':input.enabled, 'btn-danger': !input.enabled}"
                  v-on:click="switchEnable('0')")
                  i.fa.fa-power-off
                  | {{ input.enabled ? 'ON' : 'OFF' }}
              .function__single.col-xs-6
                button.btn.btn-default.col-xs-12(v-on:click="toReset('0')" v-bind:disabled='!input.enabled')
                  i.fa.fa-refresh
                  |Reset
          section.input_group.col-lg-9.col-md-11.col-sm-11.col-xs-12.col-centered.clearfix
            .input__inner.clearfix.col-lg-9.col-md-11.no_pad.col-centered
              .voltage.input__single.col-lg-4.col-md-4.col-sm-4.col-xs-12
                h3.input_name.col-lg-12.col-sm-12.col-xs-4 Voltage
                span.bolder.col-lg-12.col-xs-8.no_pad {{ input.voltage ? input.voltage : 0}}V
              .current.input__single.col-lg-4.col-md-4.col-sm-4.col-xs-12
                h3.input_name.col-lg-12.col-md-12.col-sm-12.col-xs-4.no_pad Current
                span.col-lg-12.col-md-12.col-sm-6.col-xs-8.no_pad.bolder {{ input.current ? input.current : 0 }}A
              .power_consumption.input__single.col-lg-4.col-md-4.col-sm-4.col-xs-12
                h3.input_name.col-lg-12.col-md-12.col-sm-12.col-xs-4.no_pad Power
                span.col-lg-12.col-md-12.col-sm-12.col-xs-8.no_pad.bolder {{inputPowerString}}
              .input_functions.function_group.col-xs-12.no_pad.visible-xs
                .function__single.col-xs-6
                  button.btn.col-xs-12.btn-default(
                    v-bind:class="{'btn-success':input.enabled, 'btn-danger': !input.enabled}"
                    v-on:click="switchEnable('0')")
                    i.fa.fa-power-off
                    | {{ input.enabled ? 'ON' : 'OFF' }}
                .function__single.col-xs-6
                  button.btn.btn-default.col-xs-12(v-on:click="toReset('0')" v-bind:disabled='!input.enabled')
                    i.fa.fa-refresh
                    |Reset
          header.outlet_header.clearfix
            h2.title_bar.col-sm-7.col-lg-7.clearfix Output
            .col-lg-2.col-sm-3.hidden-xs
              button.btn.btn-default.col-xs-12(v-on:click='toResetAll') Reset All Outlets
          section.outlet_group.col-lg-9.col-md-11.col-sm-11.col-xs-12.col-centered.clearfix
            .outlet__inner.col-lg-9.col-md-11.no_pad.col-centered
              .bank.outlet__single(v-for='(bankKey,bank) in banks' ).clearfix
                .title
                  span Outlet{{ bankKey }}
                //- Function group for Pad and PC
                .function_group.col-sm-2.col-md-2.col-lg-2.hidden-xs
                  .col-xs-12
                    button.btn.btn-default(
                      v-bind:class="{'btn-success':bank.enabled,'btn-danger': !bank.enabled}"
                      v-on:click='switchEnable(bankKey)'
                      v-bind:disabled="bank.locked").col-xs-12
                      i.fa.fa-power-off
                      | {{ bank.enabled ? 'ON' : 'OFF' }}
                  .col-xs-12
                    button.btn.btn-default.col-xs-12(v-on:click='toReset(bankKey)' v-bind:disabled='!bank.enabled')
                      i.fa.fa-refresh
                      |Reset
                .info.col-lg-4.col-md-5.col-sm-5.clearfix
                  .current.clearfix
                    h3.col-lg-4.col-sm-4.col-xs-4 Current
                    h3.col-lg-offset-1.col-lg-6.col-sm-3.col-xs-6.bolder.no_pad {{ input.enabled && bank.enabled ? bank.current : '0' }}A
                    //- .col-lg-12.col-sm-12.col-xs-9.bar
                      div
                  .power_consumption.clearfix
                    h3.col-lg-4.col-sm-4.col-xs-4 Power
                    h3.col-lg-offset-1.col-lg-6.col-md-2.col-sm-5.col-xs-6.bolder.no_pad {{ input.enabled && bank.enabled ? bank.power : '0' }}W
                    //- .col-lg-12.col-xs-9.bar
                      div
                //- Function group for Mobile
                .function_group.col-xs-12.visible-xs
                  .col-xs-6
                    button.btn.btn-default(
                      v-bind:class="{'btn-success':bank.enabled,'btn-danger': !bank.enabled}"
                      v-bind:disabled="bank.locked"
                      v-on:click='switchEnable(bankKey)').col-xs-12
                      i.fa.fa-power-off
                      | {{ bank.enabled ? 'ON' : 'OFF' }}
                  .col-xs-6
                    button.btn.btn-default.col-xs-12(v-on:click='toReset(bankKey)' v-bind:disabled='!bank.enabled')
                      i.fa.fa-refresh
                      |Reset
                //- Outlet for Mobile
                .outlet_group.col-xs-12.visible-xs
                  .edit(v-on:click='handleOutletConfig(bankKey, bank)')
                    i.fa.fa-pencil
                  .outlet__single.col-xs-12.clearfix(v-for='(outletKey,outlet) in bank.outlets')
                    .outlet_num
                      | {{ bankKey }}
                    .outlet_name
                      | {{ outlet.name }}
                    .outlet_btn(v-bind:class="{enabled:bank.enabled}")
                      button.btn.locked_outlet(v-if="bank.locked && bank.enabled")
                        i.fa.fa-lock
                      button.btn.outlet__btn__inner(v-else="!bank.enabled")
                //- Outlet for PC
                .outlet_group.hidden-xs(v-on:click='handleOutletConfig(bankKey,bank)')
                  .outlet__single.clearfix(v-for='(outletKey,outlet) in bank.outlets')
                    .outlet_single_header.col-sm-12
                      | {{ outlet.name }}
                      .edit(v-on:click='handleOutletConfig(bankKey, bank)')
                        i.fa.fa-pencil
                    .outlet_body.clearfix
                      .outlet_btn(v-bind:class="{enabled:bank.enabled}")
                        button.btn.locked_outlet(v-if="bank.locked && bank.enabled")
                          i.fa.fa-lock
                        button.btn.outlet__btn__inner(v-else="!bank.enabled")
          .col-xs-12.row_space--xs.visible-xs
            button.btn.btn-default.col-xs-12(v-on:click="toResetAll") Reset All Outlets

  modal(v-bind:title.sync="editing.title"
        v-bind:show.sync="showConfig"
        effect="zoom"
        v-bind:callback="handleOutletApply"
        ok-text="Apply"
        cancel-text="Cancel").bank_config
        .modal-body.clearfix(slot="modal-body")
          .outlet.input__single.col-xs-12(v-for='(key,o) in editing.outlets')
            label Name
            input.form-control(type='text' v-model='o.name' maxLength='7')
            span.error(v-show='outletNameValid[editing._id][key].invalid')
              | English characters , numbers and '_' only
</template>

<script>
import { call } from 'src/Service.js'
import { modal } from 'vue-strap'
import _ from 'lodash'
import moment from 'moment'
const DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss'

export default {
  components: {
    modal
  },
  data () {
    return {
      input: {
        enabled: false
      },
      banks: {},
      outletNameValid: {},
      showConfig: false,
      showConfirm: false,
      editing: {
        _id: null,
        title: '',
        locked: null,
        outlets: []
      },
      confirm: {
        msg: '',
        cb: function () {}
      },
      currentTime: '',
      timezone: {}
    }
  },
  asyncData () {
    call(this.$route.params.mac, 'dxGetPowerStatus').then(data => {
      this.input = _.cloneDeep(data.input)
      this.banks = _.cloneDeep(data.banks)
      return call(this.$route.params.mac, 'dxGetTimeZone')
    }).then(({timezone}) => {
      console.log(timezone)
      this.timezone = timezone
    }).catch(err => {
      this.alert('danger', 'No response', err)
    })
  },
  computed: {
    deviceTime () {
      if (this.timezone.useDaylight && moment().isDST()) {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT)
      } else {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT)
      }
    },
    inputPowerString () {
      let str = ''
      if (this.input.power > 1000) {
        str = (this.input.power / 1000).toFixed(2) + 'KW'
      } else {
        str = this.input.power + 'W'
      }
      return str || 0
    }
  },
  methods: {
    updateTime () {
      this.currentTime = Date.now()
      let vue = this
      setTimeout(function () {
        vue.updateTime()
      }, 1000)
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    handleOutletConfig (key, bank) {
      this.editing._id = key
      this.editing.title = 'Outlet' + key
      this.editing.outlets = _.cloneDeep(bank.outlets)
      this.editing.locked = bank.locked
      this.showConfig = true
    },
    nameValid (val) {
      return /^[0-9A-Za-z\s_]{1,}$/.test(val)
    },
    handleOutletApply () {
      for (let key in this.editing.outlets) {
        // trim the name
        this.editing.outlets[key].name = this.editing.outlets[key].name.trim()
        if (!this.nameValid(this.editing.outlets[key].name)) return this.alert('danger', '', 'Please enter valid outlet name, number and english characters only')
      }

      this.setBankInfo()
      this.showConfig = false
    },
    lockChged () {
      if (this.banks[this.editing._id].locked === this.editing.locked) {
        return false
      } else {
        return true
      }
    },
    portChged () {
      for (let port in this.banks[this.editing._id].outlets) {
        if (this.editing.outlets[port].name !== this.banks[this.editing._id].outlets[port].name) {
          return true
        }
      }
      return false
    },
    // handleConfirm () {
    //   this.confirm.msg = 'Hitting this will reset this device, do you want to continue?'
    //   this.confirm.cb = () => {
    //     this.toReset(0)
    //     this.showConfirm = false
    //   }
    //   this.showConfirm = true
    // },
    switchEnable (key) {
      let newParam = {
        banks: [key],
        enabled: key === '0' ? !this.input.enabled : !this.banks[key].enabled
      }
      // console.log('in switchEnable', newParam)
      this.sendAPI('dxEnableBank', newParam)
    },
    switchLock (key) {
      let newParam = {
        banks: [key],
        locked: key === 0 ? !this.input.locked : this.editing.locked
        // lock button of input is triggered when clicked, but others are not
      }
      // console.log('in switchLock', newParam)
      this.sendAPI('dxLockBank', newParam)
    },
    toReset (key) {
      this.sendAPI('dxResetBank', {
        banks: [key]
      })
    },
    async toResetAll () {
      console.log('reset all')
      let mac = this.$route.params.mac
      try {
        for (let i = 1; i <= Object.keys(this.banks).length; i++) {
          await call(mac, 'dxResetBank', {
            banks: [i.toString()]
          })
        }
      } catch (err) {
        console.error(err)
      }
    },
    setBankInfo () {
      this.sendAPI('dxSetBankInfo', {
        banks: {
          [this.editing._id]: {
            outlets: this.editing.outlets
          }
        }
      })
    },
    sendAPI (cmd, params) {
      call(this.$route.params.mac, cmd, params).then(res => {
        console.log(res)
      }, err => {
        this.alert('danger', '', err)
      })
    }
  },
  ready () {
    this.updateTime()
  },
  events: {
    update (mac, {type, event, msg}) {
      console.log('type: ', type)
      console.log('event: ', event)
      console.log('msg: ', msg)
      if (type === 'info') {
        let key = event.banks[0]
        if (this.banks[key].outlets) {
          this.banks[key].outlets = _.cloneDeep(event.outlets)
        }
      } else if (type === 'lock') {
        if (event.banks[0] > 0) {
          this.banks[event.banks[0]].locked = event.locked
        } else {
          this.input.locked = event.locked
        }
      } else if (type === 'enable') {
        if (event.banks.length > 0) {
          for (let key of event.banks) {
            if (key === '0') {
              this.input.enabled = event.enabled
            } else {
              this.banks[key].enabled = event.enabled
            }
          }
          // this.banks[event.banks[0]].enabled = event.enabled
        }
      } else if (type === 'reset') {
      } else if (type === 'timezone') {
        this.timezone = event.timezone
      }
    },
    status (mac, { banks, input }) {
      // console.log('status')
      // console.log(banks)
      // console.log(input)
      this.input.voltage = input.voltage
      this.input.current = input.current
      this.input.power = input.power
      for (let key of Object.keys(banks)) {
        // console.log(key)
        // console.log(this.banks[key])
        _.assignIn(this.banks[key], {
          current: banks[key].current,
          power: banks[key].power
        })
      }
    }
  },
  route: { // add these code to index of every type of devices to reload data
    canReuse: false, // can't reuse so forces it to reload data
    activate ({next}) {
      next()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';
  @import '~sass/_mixin.scss';

  /* ======== BASE ON MOBILE ===================== */

  /* ======== global component setting =========== */
  .status_header,.outlet_header{
    padding-top: $space_xs;
  }
  /* ======== input info ========================= */
  .input_group{
    padding-bottom: $space_sm;
  }
  .input__inner{
    color: $PowerStatus_banner_fg;
    background-color: $PowerStatus_banner_bg;
    border:1px solid $PowerStatus_banner_border;
    padding:$space_xxs;
    border-radius: $base_border_radius;
    & .bar{
      @include progressBar(150px,18px,70%,#3af,#1895e0,-130deg);
      padding-left: 0px;
      padding-right: 0px;
    }
    .current_bar{
      & > div {
        width: 55%;
      }
    }
    .voltage{
      .input_name{
        padding-left: 0;
        padding-right: 0;
      }
    }
    .bolder{
      font-size: 16px;
    }
  }
  .input_functions{
    padding-top: $space_xxs;
  }


  .outlet_header{
    border-top: 1px solid $pri_gray;
  }
  /* ========= outer__inner ====================== */
  .outlet__inner{

  }

  /* ========= banks ============================= */
  .bank{
    margin:15px 0 30px 0;
    border-radius: $base_border_radius;
    color: $PowerStatus_bank_fg;
    background-color: $PowerStatus_bank_bg;
    border:1px solid $PowerStatus_bank_border;
    border-bottom:4px solid $PowerStatus_bank_border;
    border-right: 1px solid $PowerStatus_bank_border;
    padding:$space_xs;
    & .title{
      /* background-color: ; */
      background: linear-gradient($PowerStatus_bank_title_bg 0%, darken($PowerStatus_bank_title_bg, 10%) 100%);
      & span::after{
          border-left: 4px solid darken($PowerStatus_bank_title_bg, 30%);
      }
    }

    .title {
      position: relative;
      padding:7px;
      text-transform:capitalize;
      text-align: center;
      color:$base_white;
      font-size: 14px;
      font-weight: 900;
      margin-left: -3px;
      margin-top:-30px;
      max-width: 80px;
      box-shadow:0 2px 5px rgba(0, 0, 0, 0.2);
      & span::after{
        content:"";
        position: absolute;
        left: 100%;
        top: 0;
        display:block;
        border-top:15px solid transparent;
        border-bottom:0px solid transparent;
        /* border-left:4px solid darken($bank_blue, 10%); */
      }
    }
    .info{
      border-bottom:1px dashed #aaa;
      padding:$space_xxs;
      h3{
        font-size: 16px;
      }
      h3.bolder{
        font-size: 22px;
        margin-right: $space_xxs;
      }
      & .bar {
        @include progressBar(150px,18px,70%,#3af,#1895e0,-130deg);
        padding-left: 0px;
        padding-right: 0px;
      }
    }
    .current, .power_consumption{
      margin-bottom: 10px;
      & > h3{
        padding-left: 0;
      }
    }
    .function_group{
      padding:$space_xs 0;
    }
    .outlet_group{
      background-color: $PowerStatus_bank_outlet_group_bg;
      border-radius:$base_border_radius;
      border:1px solid #5f5f5f;
      float: left;
      max-width: 40%;
      position: relative;

      &.visible-xs{
        max-width: 100%;
        padding-top: 5px;
        text-align: center;

        & .outlet_num{
          padding-left: 5px;
        }
      }

      @include breakpoint(lg) {
        max-width: 50%;
      }

      & .outlet__single{
        font-size: 16px;
        padding:$space_xxs;

        & > div{
          display:inline-block;
          vertical-align:middle;
          min-height:50px;
        }
      }

      &.hidden-xs .outlet__single{
        float: left;
        @include breakpoint(sm) {
          width: 80px;
          height: 120px;
        }
        @include breakpoint(md) {
          width: 98px;
          height: 120px;
        }
        @include breakpoint(lg) {
          width:  111px;
          height: 120px;
        }
      }

      & .outlet_num{
        width: 20%;
        white-space:nowrap;
        line-height:50px;
      }

      & .outlet_name{
        width: 55%;
        margin-left: -5px;
        line-height:50px;
        text-align:center;
      }

      & .outlet_btn{
        width: 25%;
        /* normal */
        .outlet__btn__inner{
          display:inline-block;
          vertical-align:middle;
          @include outletBtn(50px,$base_black,$base_white);
          opacity:.3;
        }
        /* enabled */
        &.enabled{
          .outlet__btn__inner{
            @include outletBtn(50px,$pri_green,$base_white);
            opacity: 1;
          }
        }
        /* locked */
        .locked_outlet{
          width: 50px;
          height: 40px;
          background-color:$pri_green;
          color:$pri_red;
          font-size: 30px;
          line-height:30px;
          & i {
            margin-right: 0px;
          }
        }

      }

      & .edit {
        cursor: pointer;
        position: absolute;
        z-index: 5;
      }
    }
  } /* clos .bank */
  .btn .fa{
    margin-right: 5px;
  }
  /* ============== Bank config modal =====================*/
  .bank_config{
    label{
      font-size: 16px;
    }
    .form-control{
      font-size: 12px;
    }
    .lock{
      label{
        margin-right: 10px;
      }
    }
  }


/* ================= sm up general styles ================== */
  @media screen and (min-width: 768px) {
    /* input */
    .voltage{
      .bolder{
        margin-top: 0;
        padding-left: 0;
        font-size: 20px;
        line-height: 20px;
      }
    }
    .current, .power_consumption{
      .bolder{
        /* padding-top: 15px; */
        font-size: 20px;
        line-height: 20px;
      }
    }
    .input__inner{
      .bar{
        @include progressBar(220px,24px,70%,#3af,#1895e0,-130deg);
      }
    }
    /* Banks */
    .bank {
      .title{
        padding:10px;
        font-size: 14px;
        box-shadow:0 2px 5px rgba(0, 0, 0, 0.2);
        text-align: center;
        /* & span::after{
          border-left:4px solid darken($bank_blue, 10%);
        } */
      }
      /* &:nth-child(2){
        .title span::after{
          border-left: 4px solid darken($bank_green, 10%);
        }
      }
      &:nth-child(3){
        .title span::after{
          border-left: 4px solid darken($bank_yellow, 10%);
        }
      } */

      .info > div h3{
        margin-bottom: 5px;
        margin-top: -10px;
      }
    }

    .bank .function_group{
      & > div{
        margin-bottom: 15px;
      }
    }
    .bank .info{
      border-bottom: none;
      h3{
        padding: 0;
        padding-right: 5px;
        padding-left: 15px;
        float: left;
        clear: right;
      }
      .current{
        margin-bottom: 25px;
        padding-top: 20px;
      }
      .power_consumption{
        padding-top: 10px;
      }
    }
    .bank .outlet_group{
      overflow: hidden;
      .outlet__single{
        padding: 0;
        .outlet_single_header{
          min-height: initial;
          vertical-align: top;
          padding: 5px 5px 5px 8px;
          text-align: left;
          background-color: $PowerStatus_bank_outlet_single_header_bg;
          white-space: nowrap;
          position: relative;

          @include breakpoint(md){
            font-size: 14px;
          }
          @include breakpoint(sm){
            font-size: 12px;
          }
          @include breakpoint(xs){
            font-size: 12px;
          }
        }
      }
      .outlet_body{
        width: 100%;
        padding: 23px 0px;
        .outlet_btn{
          width: 100%;
          .outlet__btn__inner, .locked_outlet{
            margin-left: auto;
            margin-right: auto;
            display: block;
          }
        }
      }

      & .edit {
        cursor: pointer;
        position: absolute;
        z-index: 5;
        top: 3px;
        right: 5px;
      }
    }

  } /* close general */

  @include breakpoint(md){
    .input__inner{
      .bar{
        @include progressBar(300px,26px,70%,#3af,#1895e0,-130deg);
      }
      .bolder{
        font-size: 24px;
      }
    }
  }

  @include breakpoint(lg){
    .input__inner{
      .bar{
        @include progressBar(300px,28px,70%,#3af,#1895e0,-130deg);
      }
      .bolder{
        font-size: 26px;
      }
    }
    .bank .info .bar{
      @include progressBar(250px,22px,70%,#3af,#1895e0,-130deg);
    }
  }

</style>



// WEBPACK FOOTER //
// Status.vue?00ffea44